import React, { useState } from "react";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaCheckCircle } from "react-icons/fa";

function ContactUs() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        message: "",
    });
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                access_key: "95a4417c-752c-425d-b691-20bac578b6c8",
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                message: formData.message,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setFormSubmitted(true);
                    setFormData({ name: "", email: "", mobile: "", message: "" });
                } else {
                    alert("Failed to send message. Please try again later.");
                }
            })
            .catch((error) => {
                console.error("Error sending email:", error);
                alert("Failed to send message. Please try again later.");
            });
    };

    const closeOverlay = () => setFormSubmitted(false);

    return (
        <main className="inner-page">
            <section className="inner-hero" aria-labelledby="contact-title">
                <div className="ciits-container">
                    <div className="inner-hero-content">
                        <span className="ciits-eyebrow">Start a conversation</span>
                        <h1 id="contact-title">Contact <span className="gradient-text">Us</span></h1>
                        <p>
                            Have a question or want to work with us? Fill out the form below and our team will get in touch!
                        </p>
                    </div>
                </div>
            </section>

            <section className="contact-section" aria-label="Contact form and company contact details">
                <div className="ciits-container contact-grid">
                    <aside className="contact-info-panel">
                        <h2>Let's build something meaningful.</h2>
                        <p>
                            Have a question or want to work with us? Fill out the form below and our team will get in touch!
                        </p>

                        <div className="contact-details">
                            <div className="contact-detail">
                                <div className="contact-detail-icon"><FaEnvelope /></div>
                                <div>
                                    <small>Email</small>
                                    <a href="mailto:contact@ciits.in">contact@ciits.in</a>
                                </div>
                            </div>
                            <div className="contact-detail">
                                <div className="contact-detail-icon"><FaPhoneAlt /></div>
                                <div>
                                    <small>Phone</small>
                                    <a href="tel:+918770746285">+91 8770746285</a>
                                </div>
                            </div>
                            <div className="contact-detail">
                                <div className="contact-detail-icon"><FaMapMarkerAlt /></div>
                                <div>
                                    <small>Our Address</small>
                                    <span>
                                        CIITS Office, 123, IT Park Road, Bhopal, Madhya Pradesh, India - 462001
                                    </span>
                                </div>
                            </div>
                        </div>
                    </aside>

                    <div className="contact-form-panel">
                        <form className="contact-form-modern" onSubmit={handleSubmit} autoComplete="off">
                            <div className="form-field">
                                <label htmlFor="contact-name">Your Name</label>
                                <input
                                    id="contact-name"
                                    className="form-control-modern"
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Your Name"
                                    required
                                />
                            </div>

                            <div className="form-field">
                                <label htmlFor="contact-email">Your Email</label>
                                <input
                                    id="contact-email"
                                    className="form-control-modern"
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Your Email"
                                    required
                                />
                            </div>

                            <div className="form-field">
                                <label htmlFor="contact-mobile">Your Mobile Number</label>
                                <input
                                    id="contact-mobile"
                                    className="form-control-modern"
                                    type="tel"
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    placeholder="Your Mobile Number"
                                    required
                                />
                            </div>

                            <div className="form-field">
                                <label htmlFor="contact-message">Your Message</label>
                                <textarea
                                    id="contact-message"
                                    className="form-control-modern"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Your Message"
                                    required
                                />
                            </div>

                            <button className="submit-btn-modern" type="submit">
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </section>

            {formSubmitted && (
                <div className="success-overlay" role="dialog" aria-modal="true" aria-label="Message sent successfully">
                    <div className="success-card">
                        <FaCheckCircle size={42} style={{ color: "#30d391", marginBottom: 18 }} />
                        <h3>Thank you for reaching out!</h3>
                        <p>We have received your message and will get back to you soon.</p>
                        <button className="ciits-btn ciits-btn--primary" onClick={closeOverlay}>
                            Close
                        </button>
                    </div>
                </div>
            )}
        </main>
    );
}

export default ContactUs;
